// extracted by css-extract-rspack-plugin
export default {"infoPanel":"LjhFQ","card":"OgckJ","fieldRow":"VmPNC","fkLink":"baWYW","fieldName":"ruPsc"};